import {
	getAiBudgetQueryOptions,
	getCostSummaryQueryOptions,
	getLlmUsageQueryOptions,
	getPlatformUsageQueryOptions,
	getSubscriptionQueryOptions,
	getTrialStatusQueryOptions,
} from "@packages/api-client/hooks/platformBillingController";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { PlatformPlanContent } from "@/components/PlatformPlanContent";
import { SyncSubscriptionButton } from "@/components/SyncSubscriptionButton";
import { SettingsLayout } from "@/routes/_auth/app/_app/org/$orgId/settings/-components/SettingsLayout";

export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/settings/platform-plan/",
)({
	loader: async ({ context, params }) => {
		const orgId = params.orgId;

		// Pre-load all billing data to avoid blank screen during navigation
		// Note: Plans are now static, no need to fetch
		context.queryClient.ensureQueryData(getSubscriptionQueryOptions(orgId));
		context.queryClient.ensureQueryData(getPlatformUsageQueryOptions(orgId));
		context.queryClient.ensureQueryData(getTrialStatusQueryOptions(orgId));
		context.queryClient.ensureQueryData(getLlmUsageQueryOptions(orgId));
		// AI budget breakdown + active top-up credits (native currency, FX-independent).
		context.queryClient.ensureQueryData(getAiBudgetQueryOptions(orgId));
		// cost-summary can fail closed (e.g. missing FX rate); swallow the prefetch
		// rejection so it doesn't surface as an unhandled error. The component reads
		// it with a non-suspense useQuery and degrades that block on failure.
		context.queryClient
			.ensureQueryData(getCostSummaryQueryOptions(orgId))
			.catch(() => {});
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { t } = useTranslation();
	const { orgId } = Route.useParams();

	return (
		<SettingsLayout
			activeTab="platform-plan"
			title={t("common.subscription")}
			actions={<SyncSubscriptionButton orgId={orgId} />}
			testId="billing-settings-container"
		>
			<PlatformPlanContent orgId={orgId} />
		</SettingsLayout>
	);
}
